import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAccount } from "../../auth/AuthProvider";
import { Dropdown } from "./Dropdown";
export function ProfileMenu() {
  const account = useAccount(),
    navigate = useNavigate(),
    [error, setError] = useState("");
  const user = account.user;
  return (
    <div className="nb-profile-menu">
      <Dropdown
        ariaLabel="User menu"
        label={
          <span
            className="nb-profile-link"
            style={{ background: "#000", color: "#fff" }}
            title={user?.displayName || user?.email || "Account"}
          >
            {user?.profile
              ? `${user.profile.firstName[0] || ""}${user.profile.lastName[0] || ""}`.toUpperCase()
              : (user?.displayName || "A")
                  .trim()
                  .split(/\s+/)
                  .filter(Boolean)
                  .slice(0, 2)
                  .map((part) => part[0])
                  .join("")
                  .toUpperCase()}
          </span>
        }
        actions={[
          { label: user?.displayName || "Aldapa account", disabled: true },
          { label: user?.email || "", disabled: true },
          { label: "Account", run: () => navigate("/app/profile") },
          {
            label: "Linked Accounts",
            run: () => navigate("/app/profile#linked"),
          },
          { label: "Settings", run: () => navigate("/app/profile#settings") },
          {
            label: "Sign Out",
            run: () => {
              void account
                .logout()
                .then(() => navigate("/"))
                .catch(() => setError("Unable to sign out. Try again."));
            },
          },
        ]}
      />
      {error && <span role="alert">{error}</span>}
    </div>
  );
}
